module.exports = __webpack_public_path__ + "static/media/coffe.4b72bd33.jpeg";